import AvailableJobs from "views-interpreters/AvailableJobs";
import AssignedJobs from "views-interpreters/AssignedJobs";
import CompletedJobs from "views-interpreters/CompletedJobs";
import Dashboard from "views-interpreters/Dashboard";
import Payments from "views-interpreters/Payments";
import Invoices from "views-interpreters/Invoices";
import Profile from "views-interpreters/profile";
import Translation from "views-interpreters/Translations/Translation";
import TranslationView from "views-interpreters/Translations/TranslationView";
import ChangePassword from "views/ChangePassword";


var routesInterpreters = [
  {
    path: "/dashboard",
    title:"Dashboard",
    icon: "/images/Reports.png",
    iconActive: "/images/Reports-fill.png",
    component: <Dashboard />,
    layout: "/interpreter",
  },
  {
    path: "/available-jobs",
    title:"Available Jobs",
    icon: "/images/clipboard-regular.svg",
    iconActive: "/images/clipboard-list-solid.svg",
    component: <AvailableJobs />,
    layout: "/interpreter",
  },
  {
    path: "/assigned-jobs",
    title:"Assigned Jobs",
    icon: "/images/user-check-regular.svg",
    iconActive: "/images/user-check-solid.svg",
    component: <AssignedJobs />,
    layout: "/interpreter",
  },
  {
    path: "/completed-jobs",
    title:"Completed Jobs",
    icon: "/images/clipboard-check-regular.svg",
    iconActive: "/images/clipboard-check-solid.svg",
    component: <CompletedJobs />,
    layout: "/interpreter",
  },
  
  
  // {
  //   path: "/translation",
  //   title:"Translations",
  //   icon: "/images/Reports.png",
  //   iconActive: "/images/Reports-fill.png",
  //   component: <Translation />,
  //   layout: "/interpreter",
  // },
  // {
  //   path: "/translation/view/:id",
  //   subRoute: true,
  //   component: <TranslationView />,
  //   layout: "/interpreter",
  // },
  // {
  //   path: "/payments",
  //   title: "Payments",
  //   icon: "/images/admin.png",
  //   iconActive: "/images/admin-active.png",
  //   component:  <Payments/>,
  //   layout: "/interpreter",
  // },
  // {
  //   path: "/invoices",
  //   title: "Invoices",
  //   icon: "/images/admin.png",
  //   iconActive: "/images/admin-active.png",
  //   component:  <Invoices/>,
  //   layout: "/interpreter",
  // },
  {
    path: "/profile",
    subRoute: true,
    component:  <Profile/>,
    layout: "/interpreter",
  },
  {
    path: "/change-password",
    subRoute: true,
    component: <ChangePassword />,
    layout: "/interpreter",
  },
];
export default routesInterpreters;
